export enum CryptoServiceError {
  PasswordLengthNotValid = 'crypto-service/password-length-not-valid',
}
